import { SET_MAP_DEFAULT_STATE, SET_MAP_STATE } from '../constants';
import { getInitialState } from './initialState';
export const zoomLevelShortcuts = (state = getInitialState().zoomLevelShortcuts, action) => {
    switch (action.type) {
        case SET_MAP_DEFAULT_STATE: {
            return getInitialState().zoomLevelShortcuts;
        }
        case SET_MAP_STATE: {
            return action.payload.zoomLevelShortcuts || state;
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=zoomLevelShortcuts.js.map